module.exports = __webpack_public_path__ + "secundo_logo.svg?28403368563853542e2df419477d0445";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/secundo_logo.svg
// module id = 273
// module chunks = 0